import { AccountModel } from './account.model';

export class AccountFactory {
  public static new(data?: Partial<AccountModel>): AccountModel {
    return new AccountModel(data);
  }

  public static getModel(): any {
    return AccountModel;
  }

  public static getPath(): string {
    return 'accounts';
  }
}
